const pending = new WeakMap();
/** Serialize route changes: a slow Bluetooth request must not win over default. */
export function routeCallAudio(element, id) {
    const sink = element;
    if (!sink || typeof sink.setSinkId !== "function")
        return;
    const next = (pending.get(sink) || Promise.resolve()).then(async () => {
        try {
            await sink.setSinkId(id);
        }
        catch {
            // A rejected/disconnected route must not leave remote speech inaudible.
            if (id) {
                try {
                    await sink.setSinkId("");
                }
                catch { /* system routing may be required */ }
            }
            window.dispatchEvent(new Event("call-audio-route-error"));
        }
    });
    pending.set(sink, next);
}
